var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 411,
    height: 402,
    viewBox: "0 0 411 402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6",
    x: 2,
    y: 0,
    width: 409,
    height: 402,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 9,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.09
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration",
    transform: "translate(-1100 -312)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1100, 312)",
    filter: "url(#Rectangle_6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6-2",
    "data-name": "Rectangle 6",
    width: 355,
    height: 348,
    rx: 31,
    transform: "translate(29 18)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component_4_1",
    "data-name": "Component 4 \\u2013 1",
    transform: "translate(1100 395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-1119 -230)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(1119 386)",
    fill: "#fff",
    stroke: "#d5d5d5",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1132.312,416.46l7.333,7.333,9.648-9.648,4.718-4.718",
    transform: "translate(4.839 -1.611)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 235,
    height: 13,
    rx: 6.5,
    transform: "translate(1221 393)",
    fill: "#b2ddcc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 56,
    height: 13,
    rx: 6.5,
    transform: "translate(1221 417)",
    fill: "#b2ddcc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 13,
    height: 13,
    rx: 6.5,
    transform: "translate(1443 417)",
    fill: "#b2ddcc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 13,
    height: 13,
    rx: 6.5,
    transform: "translate(1425 417)",
    fill: "#b2ddcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-1119 -308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1-2",
    "data-name": "Ellipse 1",
    transform: "translate(1119 386)",
    fill: "#fff",
    stroke: "#d5d5d5",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2",
    "data-name": "Path 1",
    d: "M1132.312,416.46l7.333,7.333,9.648-9.648,4.718-4.718",
    transform: "translate(4.839 -1.611)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-2",
    "data-name": "Rectangle 7",
    width: 235,
    height: 13,
    rx: 6.5,
    transform: "translate(1221 393)",
    fill: "#f9d5a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8-2",
    "data-name": "Rectangle 8",
    width: 56,
    height: 13,
    rx: 6.5,
    transform: "translate(1221 417)",
    fill: "#f9d5a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9-2",
    "data-name": "Rectangle 9",
    width: 13,
    height: 13,
    rx: 6.5,
    transform: "translate(1443 417)",
    fill: "#f9d5a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10-2",
    "data-name": "Rectangle 10",
    width: 13,
    height: 13,
    rx: 6.5,
    transform: "translate(1425 417)",
    fill: "#f9d5a5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-1119 -386)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1-3",
    "data-name": "Ellipse 1",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(1119 386)",
    fill: "#1fc41f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1-3",
    "data-name": "Path 1",
    d: "M1132.312,416.46l7.333,7.333,9.648-9.648,4.718-4.718",
    transform: "translate(4.839 -1.611)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-3",
    "data-name": "Rectangle 7",
    width: 235,
    height: 13,
    rx: 6.5,
    transform: "translate(1221 393)",
    fill: "#e9d5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8-3",
    "data-name": "Rectangle 8",
    width: 56,
    height: 13,
    rx: 6.5,
    transform: "translate(1221 417)",
    fill: "#e9d5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9-3",
    "data-name": "Rectangle 9",
    width: 13,
    height: 13,
    rx: 6.5,
    transform: "translate(1443 417)",
    fill: "#e9d5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10-3",
    "data-name": "Rectangle 10",
    width: 13,
    height: 13,
    rx: 6.5,
    transform: "translate(1425 417)",
    fill: "#e9d5f5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.5165fe59ccde71965562da8f9645cb68.svg";
export { ForwardRef as ReactComponent };